import React from 'react';
import PropTypes from 'prop-types';
import {COMPONENT_TYPE} from '@learningblocks/exp-constants/lib/Utilities';
import {Button} from '@learningblocks/shared-components';

/**
 * ResetButton for the Question footer component;
 */
export function ResetButton(props) {
  const onReset = () => {
    const {componentID, componentType} = props;
    props.onReset(componentID, componentType);
  };

  return (
    <Button onClick={onReset} disabled={props.disabled} style={{marginRight: '6px'}}>
      Reset
    </Button>
  );
}

ResetButton.propTypes = {
  /**
   * The unique id for the question component
   */
  componentID: PropTypes.number,
  /**
   * String for the component Type
   */
  componentType: PropTypes.oneOf([
    COMPONENT_TYPE.CSCQ,
    COMPONENT_TYPE.MSCQ,
    COMPONENT_TYPE.DDQ,
    COMPONENT_TYPE.DNDQ_COLOR,
    COMPONENT_TYPE.GROUPED_DNDQ,
    COMPONENT_TYPE.CSCQ_COLOR,
    COMPONENT_TYPE.QUESTION_TABLE,
  ]),
  /**
   * Boolean value controlling button enabled/disabled
   */
  disabled: PropTypes.bool.isRequired,
  /**
   * Callback function involked when Answer submitted
   */
  resetAnswer: PropTypes.func.isRequired,
};
